module.exports = __webpack_public_path__ + "img/mulesoft.33ad1654.png";